import React from "react";
import Modal from "@material-ui/core/Modal";

//** Using Modal in your components
// * import Modal from '../app/Modal';
// *
// * class Component extends React.Component {
// *   constructor(props) {
// *     super(props);
// *     this.state = {
// *       modalOpen: false
// *     }
// *     this.handleOpen = this.handleOpen.bind(this);
// *     this.handleClose = this.handleClose.bind(this);
// *     this.handleCloseReload = this.handleCloseReload.bind(this);
// *     this.handleCloseCustom = this.handleCloseCustom.bind(this);
// *   }
// *
// *   handleOpen() {
// *     this.setState({ modalOpen: true });
// *   }
// *
// *   handleClose() {
// *     this.setState({ modalOpen: false });
// *   }
// *
// *   handleCloseReload = () => {
// *     this.setState({ modalOpen: false });
// *     this.props.reloadData();
// *   };
// *
// *   handleCloseCustom = () => {
// *     this.setState({ modalOpen: false });
// *     this.props.doCustomAction();
// *   };
// *
// *   render() {
// *     return (
// *       <Modal modalOpen={this.state.modalOpen}>
// *         {children to be rendered}
// *       </Modal>
// *     );
// *   }

//** sets modal style
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    position: `absolute`,
    width: 400,
    maxWidth: `90%`,
    backgroundColor: "#efefef",
    border: "2px solid #000",
    padding: 10,
    color: "#000000"
  };
}

const Component = props => {
  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={props.modalOpen}
        onClose={props.handleClose}
        className="card-modal"
      >
        <div style={getModalStyle()}>{props.children}</div>
      </Modal>
    </div>
  );
};

export default Component;
